import { CheckCircle } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      className="relative py-20 bg-gradient-to-br from-white to-emerald-50 overflow-hidden"
    >
      {/* Decorative Blobs */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-emerald-100 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-pulse" />
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-teal-100 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-pulse delay-200" />

      <div className="relative max-w-5xl mx-auto text-center px-6">
        {/* Heading */}
        <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-6">
          About <span className="text-emerald-600">RideCloud</span>
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
          Our mission is to make commuting{" "}
          <span className="text-emerald-600 font-semibold">sustainable</span>,{" "}
          <span className="text-teal-600 font-semibold">affordable</span>, and{" "}
          <span className="text-emerald-600 font-semibold">stress-free</span>{" "}
          for everyone.
        </p>

        {/* Why Choose Us */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-12 text-left max-w-2xl mx-auto">
          {[
            "Eco-friendly commuting that helps save the planet",
            "Save money with shared rides and affordable fares",
            "Safe and reliable rides with trusted drivers",
            "Simple, easy-to-use platform for everyone",
          ].map((point, i) => (
            <div key={i} className="flex items-start gap-3">
              <CheckCircle className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-1" />
              <p className="text-gray-700 text-base">{point}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12">
          <a
            href="/signup"
            className="inline-block px-8 py-4 bg-gradient-to-r from-emerald-500 to-teal-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:scale-105 transition transform"
          >
            Join RideCloud
          </a>
        </div>
      </div>
    </section>
  );
}
